import {ParagraphSmall, ParagraphXSmall, HeadingMedium, ParagraphMedium } from 'baseui/typography';
import React, {Component} from 'react';
import { FlexGrid, FlexGridItem } from 'baseui/flex-grid';
import { AuthUserContext, withAuthorization } from '../../shared/Session';
import Utils from '../../shared/Utils';
import { StyledLink } from 'baseui/link';
import Logger from '../../shared/Utils/logger';
import Linkify from 'react-linkify';
import Request from '../../shared/Request';

const wrapProps = {
    overrides: {
        Block: {
            style: ({$theme}) => ({
                wordWrap: 'break-word',
                whiteSpace: 'pre-line'
            }),
        }
    }
}

class HistoryMessage extends Component {
    constructor(props) {
        super(props);

        this.data = this.props.data;
        this.color = this.props.color;
        this.username = this.props.username;
        this.show_user = this.props.show_user;
        this.state = {
            usernames: this.props.usernames
        }

        // RegEx must be wrapped in parenthesis otherwise you can get undefined results (str.plit(regex) is one example of weirdness)
        //this.mentionRegex = /(@[^\s]+)/g;
        //this.urlRegex = /([https|http]+:\/\/[^\s]+)/g;
    }

    shouldComponentUpdate = () => {
        return this.show_user; // ONly should be True if timeAgo is present in the message
    };

    /*urlify = (text) => {
        const foundUrls = text.match(this.urlRegex);
        if (foundUrls) {
            return text.split(this.urlRegex).map((subtext, idx) => this.urlRegex.test(subtext)
                ? <StyledLink key={idx} target='_blank' href={subtext} style={{color:"#00a1ff"}}>{subtext}</StyledLink>
                : subtext)
        } else {
            return text;
        }
    };*/

    openFile = (url, event) => {
      event.preventDefault();
      event.stopPropagation();
      Request.post_to_new_window({
        firebase: this.props.firebase,
        route: url
      });
    };

    renderMessageText = (data) => {
      if (data.message) {
        /*const foundUrls = data.message.match(this.mentionRegex);
        if (foundUrls) {
            return data.message.split(this.mentionRegex).map((subtext, idx) => this.mentionRegex.test(subtext)
                ? <ParagraphSmall key={idx} margin={'0px 0px 0px 0px'} display={'inline-block'} style={{fontWeight: 'bold', whiteSpace: 'pre-wrap', wordWrap: 'break-word', color: this.renderMessageStatus(data.sent)}}>{subtext} {data.sent === false ? " (failed)" : null }</ParagraphSmall>
                : <ParagraphSmall key={idx} margin={'0px 0px 0px 0px'} display={'inline-block'} style={{whiteSpace: 'pre-wrap', wordWrap: 'break-word', color: this.renderMessageStatus(data.sent)}}>{this.urlify(subtext)} {data.sent === false ? " (failed)" : null }</ParagraphSmall>)
        } else {*/
            return <Linkify componentDecorator={(decoratedHref, decoratedText, key) => (<a style={{color:"#00a1ff", overflowWrap:"break-word"}} target="blank" href={decoratedHref} key={key}>{decoratedText}</a>)}><ParagraphMedium margin={'0px 0px 0px 0px'} style={{color: this.renderMessageStatus(data.sent)}}>{/*this.urlify*/(data.message)} {data.sent === false ? " (failed)" : null }</ParagraphMedium></Linkify>
        /*}*/
      } else {
            return <ParagraphMedium margin={'0px 0px 0px 0px'} style={{color: this.renderMessageStatus(data.sent)}}><StyledLink onClick={(e) => {this.openFile(data.file_upload_url, e)}} style={{color:"#00a1ff"}} href={data.file_upload_url}>{data.file_upload_filename}</StyledLink> {data.sent === false ? " (failed)" : null }</ParagraphMedium>
      }
    };

    renderMessageStatus = (sent) => {
        if (sent === false) {
            return '#AB1300';
        } else {
            return '';
        }
    }

    renderMessage = () => {
        return <FlexGrid
                flexGridRowGap={'scale0'}
                margin={0}
            >
            {this.show_user ? <FlexGridItem>
                <HeadingMedium
                    margin={'12px 0px 0px 0px'}
                    display={'inline-block'}
                    color={this.color}
                    style={{lineHeight: '20px', fontSize:'14px', fontFamily:'roobertSemibold'}}
                >{this.data.username} {this.data.username === "Clinic" ? Utils.botTag() : null}</HeadingMedium> <ParagraphXSmall margin={0} display={'inline-block'} color={'gray'}> • {Utils.renderTimeAgo(this.data.created_at)}</ParagraphXSmall>
                </FlexGridItem> : null}
            <FlexGridItem {...wrapProps}>{this.renderMessageText(this.data)}</FlexGridItem>
        </FlexGrid>
    };

    render = () => {
        return <AuthUserContext.Consumer>
            {authUser => (
                <FlexGridItem>{this.renderMessage()}</FlexGridItem>
            )}
        </AuthUserContext.Consumer>
    }
}

const loggedInUser = authUser => !!authUser;
export default withAuthorization(loggedInUser)(HistoryMessage);
